import React from 'react';
import { Form, FormGroup, Input, Button, Label } from 'reactstrap';
import { connect } from 'react-redux';
import { handleQueryInput, handleUrlChange, makeDebuggerApiCall, handleQueryResponseStructure, handleQueryModelSize } from '../../../../redux/actions/debuggerForm';

const quickTests = [
  { url: 'https://www.cnn.com/', query: 'What are the top news stories?' },
  { url: 'https://en.wikipedia.org/wiki/Benjamin_Franklin', query: 'Where did Benny go to school?' },
  { url: 'https://www.imdb.com/title/tt8367814', query: 'Who are the main actors?' },
  { url: 'https://github.com/facebook/react', query: 'Describe this repository and what it does' },
];

const QueryForm = (props) => {
  const { queryString, responseStructure, url, modelSize, handleQueryInput, handleUrlChange, handleQueryResponseStructure, handleQueryModelSize, makeDebuggerApiCall, disabled } = props;

  // Set request count based on modelSize
  const requestCount = modelSize === 'mini' ? 200 : 100;

  return (
    <>
      <div style={{ marginTop: 24, marginBottom: 8 }}>
        <Label style={{ fontWeight: 600, marginBottom: 8, display: 'block' }}>Quick Test Links:</Label>
        {quickTests.map((test, idx) => (
          <Button
            key={idx}
            color="light"
            size="sm"
            className="btn btn-outline-primary"
            style={{ marginRight: 8, marginBottom: 8 }}
            onClick={() => {
              handleUrlChange(test.url);
              handleQueryInput(test.query);
            }}
            disabled={disabled}
          >
            {test.url.replace(/^https?:\/\//, '').split('/')[0]}
          </Button>
        ))}
      </div>
      <Form onSubmit={makeDebuggerApiCall}>
        <FormGroup>
          <Label for="query-url">Site URL</Label>
          <Input
            id="query-url"
            type="text"
            value={url}
            onChange={e => handleUrlChange(e.target.value)}
            placeholder="http://somesite.com"
            disabled={disabled}
          />
        </FormGroup>
        <FormGroup>
          <Label for="query-string">Query</Label>
          <Input
            id="query-string"
            type="text"
            value={queryString}
            onChange={e => handleQueryInput(e.target.value)}
            placeholder="Enter your query here"
            disabled={disabled}
          />
        </FormGroup>
        <FormGroup>
          <Label for="response-structure">Response Structure (optional)</Label>
          <Input
            id="response-structure"
            type="textarea"
            value={responseStructure}
            onChange={e => handleQueryResponseStructure(e.target.value)}
            placeholder="Enter desired response structure (JSON, etc)"
            disabled={disabled}
          />
        </FormGroup>
        <FormGroup tag="fieldset">
          <Label>Model Size:</Label>
          <FormGroup check>
            <Label check>
              <Input type="radio" name="modelSize" value="nano" checked={modelSize === 'nano'} onChange={() => handleQueryModelSize('nano')} disabled={disabled} />
              Nano
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input type="radio" name="modelSize" value="mini" checked={modelSize === 'mini'} onChange={() => handleQueryModelSize('mini')} disabled={disabled} />
              Mini
            </Label>
          </FormGroup>
        </FormGroup>
        <Button color="success" type="submit" disabled={disabled || !url || !queryString}>
          Submit Query | <span style={{ color: !disabled ? '#D1F1DF' : '#1b1e21', marginLeft: 4 }}>{requestCount} Requests</span>
        </Button>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => ({
  queryString: state.debuggerForm.query.options.queryString,
  responseStructure: state.debuggerForm.query.options.responseStructure,
  url: state.debuggerForm.defaultOptions.url,
  modelSize: state.debuggerForm.query.options.modelSize || 'nano',
});

const mapDispatchToProps = (dispatch) => ({
  handleQueryInput: (payload) => dispatch(handleQueryInput(payload)),
  handleQueryResponseStructure: (payload) => dispatch(handleQueryResponseStructure(payload)),
  handleUrlChange: (payload) => dispatch(handleUrlChange(payload)),
  handleQueryModelSize: (payload) => dispatch(handleQueryModelSize(payload)),
  makeDebuggerApiCall: (e) => dispatch(makeDebuggerApiCall(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(QueryForm); 